import { useContext } from 'react';
import Overlay from './Overlay';
import { StoreContext } from '../StoreProvider';

const Overlays = ({ overlays, timeOffset }) => {
    const { videoPaused, videoEnded, videoTime } = useContext(StoreContext);

    const triggers = {
        onPause: () => {
            return videoPaused && !videoEnded;
        },
        onEnd: () => {
            return videoEnded;
        },
        onDuration: (overlay) => {
            return videoTime >= overlay.triggerParams.from + timeOffset && videoTime <= overlay.triggerParams.until + timeOffset;
        }
    };

    if (!overlays || !overlays.length) {
        return null;
    }

    return (
        <>
            {overlays.map((overlay) => {
                if (!triggers[overlay.triggerType]) {
                    console.warn(`Trigger ${overlay.triggerType} doesn't exist...`);
                    return null;
                }

                return (
                    <Overlay
                        key={overlay.id}
                        overlay={overlay}
                        showOverlay={triggers[overlay.triggerType](overlay)}
                    />
                );
            })}
        </>
    )
}

export default Overlays;
